import { Address } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC } from 'react';
import { Address as AddressComponent } from '@components/content/Address/Address.component';
import { Text } from '@components/Text/Text.component';
import { YellowSunIllu } from '@illus/YellowSun.illu';
import { useTranslation } from '@locales/useTranslation.hook';
import { getAddressInfos } from '@utils/strings';
import classnames from 'classnames';

import styles from './EventInfos.module.scss';

type Props = ComponentPropsWithRef<'div'> & {
  name: string;
  address: Address;
  phone?: string;
  email?: string;
  website?: string;
};

const EventInfos: FC<Props> = ({ name, phone, email, website, address, className, ...rest }) => {
  const { t } = useTranslation(['events']);

  const addressInfos = getAddressInfos(address);

  const rootClassName = classnames(styles['event-infos'], className);

  return (
    <div className={rootClassName} {...rest}>
      <div className={styles["event-infos-title"]}>
        <YellowSunIllu />
        <h2>{t('events.infos.title')}</h2>
      </div>
      <Text className="plc-mb-m" tag="h2" variant="h4">
        {name}
      </Text>
      <AddressComponent addressInfos={addressInfos} email={email} phone={phone} website={website} />
    </div>
  );
};

export { EventInfos };
